import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Button, Card, Col, Divider, Form, Input, Row, Typography } from "antd";

import { useChangePassword } from "../../../hooks/useAccounts";
import { passwordRules } from "../../../utils/validators/generalValidators";

const { Title } = Typography;

const ChangePassword: React.FC = () => {
  const [form] = Form.useForm();
  const { userData } = useSelector((state: any) => state.entities.user);
  const [passwordError, setPasswordError] = useState("");

  const changePasswordMutation = useChangePassword();

  const onFinish = (formValues: any) => {
    changePasswordMutation.mutate({
      old_password: formValues.current_password,
      new_password: formValues.new_password,
    });
  };

  const style: React.CSSProperties = {
    // background: "#0092ff",
    padding: "8px 0",
  };

  const customInputStyle = {
    width: "100%",
    height: "40px",
    // fontSize: "16px",
  };

  return (
    <div id="profile">
      <Title level={3}>Change Password</Title>

      <Row justify="center">
        <Col xs={24} sm={24} md={18} lg={18} xl={18} span={18}>
          <Card>
            <Row justify="center" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={8}
                xl={8}
                className="gutter-row"
                span={8}
              >
                <p>
                  Email: <strong>{userData?.email}</strong>
                </p>
              </Col>
            </Row>

            <Divider />

            <Form
              form={form}
              name="changePasswordForm"
              onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              layout="vertical"
            >
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={8}
                  xl={8}
                  className="gutter-row"
                  span={8}
                ></Col>
              </Row>

              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  className="gutter-row"
                  span={8}
                >
                  <div style={style}>
                    <Form.Item
                      name="current_password"
                      label="Contraseña actual"
                      rules={[
                        ...passwordRules,
                        {
                          required: true,
                        },
                      ]}
                      help={passwordError}
                      validateStatus={passwordError ? "error" : "success"}
                    >
                      <Input.Password
                        style={customInputStyle}
                        onChange={(e) => {
                          const password = e.target.value;
                          const errorMessages = passwordRules
                            .filter((rule) => !rule.pattern.test(password))
                            .map((rule) => rule.message);

                          setPasswordError(errorMessages.join(" "));
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              <Divider />

              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  className="gutter-row"
                  span={8}
                >
                  <div style={style}>
                    <Form.Item
                      name="new_password"
                      label="Contraseña nueva"
                      rules={[
                        ...passwordRules,
                        {
                          validator: (_, value) => {
                            if (
                              value &&
                              value ===
                                form.getFieldValue("confirm_new_password")
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Passwords do not match");
                          },
                        },
                        {
                          required: true,
                        },
                      ]}
                      help={passwordError}
                      validateStatus={passwordError ? "error" : "success"}
                    >
                      <Input.Password
                        style={customInputStyle}
                        onChange={(e) => {
                          const password = e.target.value;
                          const errorMessages = passwordRules
                            .filter((rule) => !rule.pattern.test(password))
                            .map((rule) => rule.message);

                          setPasswordError(errorMessages.join(" "));
                        }}
                      />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  className="gutter-row"
                  span={8}
                >
                  <div style={style}>
                    <Form.Item
                      name="confirm_new_password"
                      label="Confirmar Contraseña nueva"
                      dependencies={["new_password"]}
                      rules={[
                        {
                          required: true,
                          message: "Please confirm your password",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue("new_password") === value
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Passwords do not match");
                          },
                        }),
                      ]}
                    >
                      <Input.Password style={customInputStyle} />
                    </Form.Item>
                  </div>
                </Col>
              </Row>

              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={8}
                  xl={8}
                  className="gutter-row"
                  span={8}
                >
                  <div style={style}>
                    <Form.Item>
                      <Button
                        type="primary"
                        style={{ width: "100%" }}
                        htmlType="submit"
                      >
                        Actualizar
                      </Button>
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ChangePassword;
